import React from 'react';
import { UsersIcon, FileTextIcon, TruckIcon, ClockIcon } from 'lucide-react';
import { StatsCard } from '../components/StatsCard';
import { StatusBadge } from '../components/StatusBadge';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, Legend } from 'recharts';
export function Dashboard() {
  const permitData = [{
    month: 'Oct',
    permits: 520
  }, {
    month: 'Nov',
    permits: 680
  }, {
    month: 'Dec',
    permits: 590
  }, {
    month: 'Jan',
    permits: 720
  }, {
    month: 'Feb',
    permits: 650
  }, {
    month: 'Mar',
    permits: 780
  }];
  const professionData = [{
    name: 'Jele (Fisher)',
    value: 45,
    color: '#1B5E20'
  }, {
    name: 'Moual (Honey)',
    value: 30,
    color: '#2E7D32'
  }, {
    name: 'Bawali (Wood)',
    value: 25,
    color: '#66BB6A'
  }];
  const recentActivity = [{
    time: '10:45 AM',
    user: 'Rahim Uddin',
    action: 'Applied for Fishing Permit',
    status: 'pending' as const
  }, {
    time: '10:30 AM',
    user: 'Station Officer - Katka',
    action: 'Approved Beneficiary: Karim Sheikh',
    status: 'approved' as const
  }, {
    time: '10:15 AM',
    user: 'Abdul Hakim',
    action: 'Started Trip to Chandpai Range',
    status: 'active' as const
  }, {
    time: '09:50 AM',
    user: 'Field Officer - Dhangmari',
    action: 'Registered New Vessel',
    status: 'approved' as const
  }, {
    time: '09:30 AM',
    user: 'Fatema Begum',
    action: 'Completed Trip',
    status: 'approved' as const
  }];
  const pendingApprovals = [{
    id: 'BEN-2024-1234',
    name: 'Jamal Hossain',
    type: 'Beneficiary Registration',
    date: '2024-03-30'
  }, {
    id: 'PER-2024-5678',
    name: 'Nur Islam',
    type: 'Fishing Permit',
    date: '2024-03-30'
  }, {
    id: 'VES-2024-9012',
    name: 'Habib Mollah',
    type: 'Vessel Registration',
    date: '2024-03-29'
  }];
  return <div className="space-y-6" data-id="element-652">
      <div data-id="element-653">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-654">Dashboard</h1>
        <p className="text-sm text-gray-600 mt-1" data-id="element-655">
          Overview of Sundarban Permit Management System
        </p>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-656">
        <StatsCard icon={<UsersIcon size={24} data-id="element-658" />} label="Total Beneficiaries" value={28450} trend={{
        value: 12,
        isPositive: true
      }} data-id="element-657" />
        <StatsCard icon={<FileTextIcon size={24} data-id="element-660" />} label="Active Permits" value={3240} trend={{
        value: 8,
        isPositive: true
      }} data-id="element-659" />
        <StatsCard icon={<TruckIcon size={24} data-id="element-662" />} label="Trips Today" value={156} trend={{
        value: 5,
        isPositive: false
      }} data-id="element-661" />
        <StatsCard icon={<ClockIcon size={24} data-id="element-664" />} label="Pending Approvals" value={42} trend={{
        value: 15,
        isPositive: false
      }} data-id="element-663" />
      </div>

      {/* Charts */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-665">
        {/* Bar Chart */}
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-666">
          <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-667">
            Permits Issued by Month
          </h3>
          <ResponsiveContainer width="100%" height={300} data-id="element-668">
            <BarChart data={permitData} data-id="element-669">
              <CartesianGrid strokeDasharray="3 3" data-id="element-670" />
              <XAxis dataKey="month" data-id="element-671" />
              <YAxis data-id="element-672" />
              <Tooltip data-id="element-673" />
              <Bar dataKey="permits" fill="#1B5E20" data-id="element-674" />
            </BarChart>
          </ResponsiveContainer>
        </div>

        {/* Pie Chart */}
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-675">
          <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-676">
            Beneficiaries by Profession
          </h3>
          <ResponsiveContainer width="100%" height={300} data-id="element-677">
            <PieChart data-id="element-678">
              <Pie data={professionData} cx="50%" cy="50%" labelLine={false} label={({
              name,
              percent
            }) => `${name}: ${(percent * 100).toFixed(0)}%`} outerRadius={80} fill="#8884d8" dataKey="value" data-id="element-679">
                {professionData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-680" />)}
              </Pie>
              <Tooltip data-id="element-681" />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Recent Activity */}
      <div className="bg-white rounded-lg border border-gray-200" data-id="element-682">
        <div className="px-6 py-4 border-b border-gray-200" data-id="element-683">
          <h3 className="text-lg font-semibold text-gray-900" data-id="element-684">
            Recent Activity
          </h3>
        </div>
        <div className="divide-y divide-gray-200" data-id="element-685">
          {recentActivity.map((activity, idx) => <div key={idx} className="px-6 py-4 flex items-center justify-between hover:bg-gray-50" data-id="element-686">
              <div className="flex-1" data-id="element-687">
                <div className="text-sm font-medium text-gray-900" data-id="element-688">
                  {activity.action}
                </div>
                <div className="text-xs text-gray-600 mt-1" data-id="element-689">
                  by {activity.user} • {activity.time}
                </div>
              </div>
              <StatusBadge status={activity.status} data-id="element-690" />
            </div>)}
        </div>
      </div>

      {/* Pending Approvals */}
      <div className="bg-white rounded-lg border border-gray-200" data-id="element-691">
        <div className="px-6 py-4 border-b border-gray-200" data-id="element-692">
          <h3 className="text-lg font-semibold text-gray-900" data-id="element-693">
            Pending Approvals
          </h3>
        </div>
        <div className="divide-y divide-gray-200" data-id="element-694">
          {pendingApprovals.map(item => <div key={item.id} className="px-6 py-4 flex items-center justify-between hover:bg-gray-50" data-id="element-695">
              <div className="flex-1" data-id="element-696">
                <div className="text-sm font-medium text-gray-900" data-id="element-697">
                  {item.name}
                </div>
                <div className="text-xs text-gray-600 mt-1" data-id="element-698">
                  {item.type} • {item.id} • {item.date}
                </div>
              </div>
              <div className="flex items-center gap-2" data-id="element-699">
                <button className="px-3 py-1.5 bg-[#1B5E20] text-white text-sm rounded-lg hover:bg-[#2E7D32]" data-id="element-700">
                  Approve
                </button>
                <button className="px-3 py-1.5 border border-gray-300 text-gray-700 text-sm rounded-lg hover:bg-gray-50" data-id="element-701">
                  Reject
                </button>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}